@if (!projectId()) {
  <app-no-content-stub imageSrc="assets/placeholders/placeholder-tasks.svg">
    <div class="flex max-w-full flex-col items-center gap-2">
      <p class="text-base font-medium text-gray-900 text-center">No tasks</p>
      <p class="text-sm text-gray-600 text-center">Save your project to start adding tasks</p>
    </div>
  </app-no-content-stub>
} @else {
  <div class="flex flex-col px-8 pt-4 pb-10">
    <app-project-tasks-list-section
      [project]="project()"
      [filters]="filters()"
      (openTask)="openTask.emit($event)"
      (openSubtask)="openSubtask.emit($event)"
      (clickTask)="clickTask.emit($event)"
      (doubleClickTask)="doubleClickTask.emit($event)"
    />

    @for (section of sections(); track section.id) {
      <app-project-tasks-list-section
        [project]="project()"
        [section]="section"
        [filters]="filters()"
        [canMoveUp]="!$first"
        [canMoveDown]="!$last"
        (openTask)="openTask.emit($event)"
        (openSubtask)="openSubtask.emit($event)"
        (clickTask)="clickTask.emit($event)"
        (doubleClickTask)="doubleClickTask.emit($event)"
      />
    }

    <app-button2 class="self-start mt-5" appearance="secondary-text" size="s" align="start" (click)="addSection()">
      <app-icon name="plus" size="l" />
      Add new section
    </app-button2>
  </div>
}
